import LinkTransiion from './LinkTransition';

export default LinkTransiion;
